export default "__VITE_ASSET__8ead8781__"